const _ = require('lodash');

module.exports = function (addressService, partnerService, $state) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.statePicker = {};

            scope.selectedBranch = function (branch) {
                addressService.setPartnerDeliveryAddress(branch);
            };

            if ($state.params.id) {
                partnerService.getPartner($state.params.id).then((response) => {
                    scope.branchAddresses = response.PartnerBranchAddress;

                    scope.states = _.uniq(_.map(scope.branchAddresses, 'State'));
                    scope.statePicker.currentState = scope.states[0];
                });
            }
        },
        template: require('./partner.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/shop/partner/partner.directive.js